var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconSearch = function SvgIconSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.8262,
    y: 33.375,
    width: 8.93108,
    height: 5.08929,
    rx: 2.18832,
    transform: "rotate(42.6998 37.8262 33.375)",
    fill: "url(#paint0_linear_34_3765)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7708 34.5529C39.1738 30.5815 39.5238 23.7928 35.5524 19.3897C31.581 14.9867 24.7923 14.6368 20.3893 18.6082C15.9862 22.5795 15.6363 29.3683 19.6077 33.7713C23.579 38.1743 30.3678 38.5243 34.7708 34.5529ZM25.5985 18.8438C22.4204 18.8438 19.844 21.4202 19.844 24.5984C19.844 25.1426 20.2851 25.5837 20.8293 25.5837C21.3735 25.5837 21.8146 25.1426 21.8146 24.5984C21.8146 22.5086 23.5087 20.8145 25.5985 20.8145C26.1427 20.8145 26.5838 20.3733 26.5838 19.8292C26.5838 19.285 26.1427 18.8438 25.5985 18.8438Z",
    fill: "url(#paint1_linear_34_3765)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_3765",
    x1: 31.5509,
    y1: 35.9196,
    x2: 48.708,
    y2: 35.9196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3985"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34_3765",
    x1: 1.75644,
    y1: 26.5805,
    x2: 43.0064,
    y2: 26.5805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3985"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/IconSearch.43e29250a0bf2c6e6e9a5cc3a339e7c9.blank.svg";